import { UPDATE_USER_CURRENCY, SET_ALL_CURRENCIES } from './actions';

const initialState = {
  currency: null,
};

export const currency = (state = initialState, { type, payload }: any = {}) => {
  switch (type) {
    case UPDATE_USER_CURRENCY: {
      const { currency, locale } = payload;
      return {
        ...state,
        currency,
        locale,
      };
    }

    case SET_ALL_CURRENCIES: {
      const { currencies } = payload;

      return {
        ...state,
        currencies,
      };
    }

    default: {
      return state;
    }
  }
};
